var elementName = 'swiper-slider-container';
if (!customElements.get(elementName)) {
  class swiperSliderContainer extends HTMLElement {
    constructor() {
      super();
      this.duration = 100;
      this.resizeDebounceTimer = null;
      this._initialized = false;
    }
    
    connectedCallback() {
      // 이미 초기화되었으면 스킵 (퀵뷰에서 재사용 시)
      if (this._initialized) return;
      
      // DOM이 완전히 로드된 후 초기화
      requestAnimationFrame(() => {
        this.initializeGallery();
      });
    }
    
    // 갤러리 초기화 (외부에서도 호출 가능)
    initializeGallery() {
      // DOM 요소 캐싱
      this.thumbItems = this.querySelectorAll('.swiper-thumb');
      this.horizontalContainer = this.querySelector('.swiper-thumb__container--horizontal');
      this.swiperthumbcontainer = this.querySelector('.swiper-thumb__container');
      this.swiper = this.querySelector('.swiper');
      
      if (!this.swiper) return;
      
      // 기존 이벤트 리스너 제거 (재초기화 시)
      this.thumbItems.forEach((item) => {
        item.removeEventListener("click", this._boundClickHandler);
      });
      
      // 이벤트 리스너 설정
      this._boundClickHandler = this.clickHandler.bind(this);
      this.thumbItems.forEach((item) => {
        item.addEventListener("click", this._boundClickHandler);
      });
      
      if(this.isTouchDevice()===false && this.horizontalContainer) {
        var _this = this;
        this.horizontalContainer.addEventListener("mouseenter", function(){
          if(window.innerWidth <= 1024) return false;
          if(_this.horizontalContainer.scrollWidth <= _this.offsetWidth) return false;
          document.body.style.paddingRight = window.innerWidth > 1024 ? _this.getScrollbarWidth() + 'px' : '';
          document.body.classList.add('overflow-hidden');
        });
        this.horizontalContainer.addEventListener("mouseleave", function(){
          if(window.innerWidth <= 1024) return false;
          if(_this.horizontalContainer.scrollWidth <= _this.offsetWidth) return false;
          document.body.classList.remove('overflow-hidden');
          document.body.style.paddingRight = '';
        });
      }
      
      // swiper 이벤트 리스너 (중복 방지)
      this.swiper.removeEventListener('slide_inited', this._boundSlideInited);
      this.swiper.removeEventListener('slide_changed_custom', this._boundSlideChanged);
      
      this._boundSlideInited = this.slideInitedCustom.bind(this);
      this._boundSlideChanged = this.slideChangedCustom.bind(this);
      
      this.swiper.addEventListener('slide_inited', this._boundSlideInited, false);
      this.swiper.addEventListener('slide_changed_custom', this._boundSlideChanged, false);

      this.closest('.product--thumbnail_slider__mobile') && this.mobileThumbSize();
      
      this._initialized = true;
      
      // 초기화 완료 클래스 추가
      this.classList.add('gallery-initialized');
    }
    
    // 재초기화 메서드 (퀵뷰용)
    reinitialize() {
      this._initialized = false;
      this.initializeGallery();
      
      // swiper가 초기화된 후 슬라이드 설정
      const swiperEl = this.querySelector('swiper-slider');
      if (swiperEl && swiperEl.swiper) {
        this.slideInitedCustom();
      }
    }
    
    isTouchDevice(){
      return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
    }
    mobileThumbSize(){
      if(window.innerWidth > 576 || !this.swiperthumbcontainer) return false;
      window.addEventListener("resize", this.debouncedResizeHandler.bind(this), false);
      this.resizeHandler();
    }
    debouncedResizeHandler(){
      // resize 이벤트 디바운스 (150ms)
      clearTimeout(this.resizeDebounceTimer);
      this.resizeDebounceTimer = setTimeout(() => {
        this.resizeHandler();
      }, 150);
    }
    resizeHandler(){
      if(!this.swiperthumbcontainer) return false;
      var w = this.swiperthumbcontainer.offsetWidth,
          item_w = (this.swiperthumbcontainer.offsetWidth - 10 * 4)/5;
      this.swiperthumbcontainer.style.setProperty('--thumb-width', `${item_w}px`);
    }
    slideInitedCustom(){
      var sect = this.closest('.shopify-section')||this.closest('.popup-modal__content__data');
      if(sect.querySelector('select-option-js.active')){
        return false;
      }
      var default_media_id = this.getAttribute('data-current-media-id');
      this.changeSlideSwiper(default_media_id, 0);
    }
    slideChangedCustom(){
      // Find active slide - handle both normal and loop mode (duplicated slides)
      var activeSlide = this.querySelector('.swiper-slide-active');
      if(!activeSlide) return false;
      
      var mediaElement = activeSlide.querySelector('[data-media-id]');
      if(!mediaElement) return false;
      
      var _this = this;
      var _id = mediaElement.getAttribute('data-media-id');
      
      if(this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024){
        setTimeout(function(){
          _this.horizontaldesign(_id);
        },0);
      }
      else{
        setTimeout(function(){
          _this.verticaldesign(_id);
        },0);
      }
      setTimeout(function(){
        _this.playActiveMedia(mediaElement);
      },100);
    }
    clickHandler(e){
      this.querySelector('.active').classList.remove('active');
      e.currentTarget.classList.add('active');

      var _id = e.currentTarget.getAttribute('data-media-id');
      this.changeSlideSwiper(_id);
    }
    changeSlideSwiper(_id, delay){
      delay = delay === undefined || delay === null ? 300 : delay;
      var swiperslider = this.querySelector('swiper-slider');

      if(!swiperslider.querySelector(`[data-media-id="${_id}"]`)) return;
      
      // Find slide index by media id
      var slides = swiperslider.querySelectorAll('.swiper-slide');
      var targetIndex = -1;
      
      slides.forEach((slide, idx) => {
        if(slide.querySelector(`[data-media-id="${_id}"]`)){
          targetIndex = idx;
        }
      });
      
      if(targetIndex >= 0){
        this.querySelector('.swiper').selectSlide(targetIndex, delay);
      }
    }
    changeSlide(_id){
      if(this.querySelector('.swiper-thumb__container--horizontal') || window.innerWidth <= 1024){
        this.horizontaldesign(_id);
      }
      else{
        this.verticaldesign(_id);
      }
      this.changeSlideSwiper(_id);
    }
    verticaldesign(...args){
      this.scrollToThumb(args[0], 'vertical');
    }
    horizontaldesign(...args){
      this.scrollToThumb(args[0], 'horizontal');
    }
    scrollToThumb(_id, direction){
      if(!this.swiperthumbcontainer) return false;
      
      var item = this.swiperthumbcontainer.querySelector(`[data-media-id="${_id}"]`);
      if(!item) return false;
      
      // 활성 상태 변경
      var activeItem = this.swiperthumbcontainer.querySelector('.active');
      if(activeItem) activeItem.classList.remove('active');
      item.classList.add('active');
      
      var temp = 0;
      var isVertical = direction === 'vertical';
      var scrollProp = isVertical ? 'scrollTop' : 'scrollLeft';
      var offsetProp = isVertical ? 'offsetTop' : 'offsetLeft';
      var sizeProp = isVertical ? 'offsetHeight' : 'offsetWidth';
      var containerOffsetProp = isVertical ? 'offsetTop' : 'offsetLeft';
      
      var itemOffset = item[offsetProp] - this.swiperthumbcontainer[containerOffsetProp];
      var containerSize = this.swiperthumbcontainer[sizeProp];
      var currentScroll = this.swiperthumbcontainer[scrollProp];
      var itemEnd = itemOffset - currentScroll + item[sizeProp];
      var delta = (!isVertical && window.innerWidth <= 576) ? 15 : 0;
      
      if(itemEnd > containerSize){
        temp = currentScroll + (itemEnd - containerSize) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, scrollProp);
      }
      else if(itemOffset < currentScroll){
        temp = currentScroll - (currentScroll - itemOffset) + delta;
        this.scrollTo(this.swiperthumbcontainer, temp, this.duration, scrollProp);
      }
    }
    playActiveMedia(activeItem) {
      const deferredMedia = activeItem.parentNode.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }
    scrollTo(el, to, duration, option) {
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d/2;
        if (t < 1) return c/2*t*t + b;
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
      };

      const element = el;
      const start = element[option],
            change = to - start,
            increment = 20;
      var currentTime = 0;
      
      const animateScroll = function(){
        currentTime += increment;
        const val = Math.easeInOutQuad(currentTime, start, change, duration);
        element[option] = val;
        if(currentTime < duration) {
          window.setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    }
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }
  customElements.define('swiper-slider-container', swiperSliderContainer);
}

elementName = 'theme-lightbox';
if (!customElements.get(elementName)) {
  class themeLightbox extends HTMLElement {
    constructor() {
      super();
      var slides = this.querySelectorAll('.swiper-slide'),
          bullets = this.querySelector('.swiper-pagination');
      window.addEventListener("resize", this.resizeHandler.bind(this), false);
      this.resizeHandler();
      this.querySelector('.theme-lightbox__toggle').addEventListener("click", this.close.bind(this), false);
    }
    resizeHandler(){
      this.querySelectorAll('.theme-lightbox__image').forEach((item) => {
        var ww = window.innerWidth - 218,
            wh = window.innerHeight - 136,
            iw = item.naturalWidth,
            ih = item.naturalHeight,
            wr = ww/iw;
        if(iw > ih ){
          if(ih*wr >= wh){
            item.classList.remove('theme-lightbox__image--wide');
          }
          else{
            item.classList.add('theme-lightbox__image--wide');
          }
        }
      });
    }
    open(data_media_id){
      this.classList.add('active');
      setTimeout(() => {
        this.classList.add('animate');
      });
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
      document.body.classList.add('overflow-hidden');

      
      var item_img = this.querySelector(`[data-media-id="${data_media_id}"]`).closest('.swiper-slide');
      const nodes = Array.prototype.slice.call( item_img.parentNode.childNodes );
      const index = nodes.indexOf(item_img);
      this.querySelector('.swiper').selectSlide(index);
    }
    close() {
      this.classList.remove('animate');
      setTimeout(() => {
        this.classList.remove('active');
      }, 500);
      document.body.classList.remove('overflow-hidden');
      document.body.style.paddingRight = '';
      window.pauseAllMedia();
    }
    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }
  customElements.define('theme-lightbox', themeLightbox);
}

elementName = 'lightbox-opener';
if (!customElements.get(elementName)) {
  class lightboxOpener extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", this.clickHandler.bind(this));
    }
    clickHandler(e){
      var id = this.getAttribute('data-id'),
          item = document.getElementById(id),
          data_media_id = this.getAttribute('data-media-id');
      item.open(data_media_id);
    }
  }
  customElements.define('lightbox-opener', lightboxOpener);
}
// ADDTOCART 버튼 호버 효과
elementName = "addtocart-hover-lift";
if (!customElements.get(elementName)) {
  class addtocartHoverLift extends HTMLElement {
    constructor() {
      super();
      this.addtocartButtons = null;
      this.mediaItems = null;
      this.hoverTimeout = null;
    }
    
    connectedCallback() {
      // ADDTOCART 버튼들과 미디어 아이템들을 찾기
      this.addtocartButtons = document.querySelectorAll(".product-form__submit.btn--addtocart-page");
      this.mediaItems = document.querySelectorAll(".product-media__item img, .product-media__item video, .product-media__item model-viewer");
      
      if (this.addtocartButtons.length > 0 && this.mediaItems.length > 0) {
        this.addtocartButtons.forEach(button => {
          button.addEventListener("mouseenter", this.handleHoverStart.bind(this));
          button.addEventListener("mouseleave", this.handleHoverEnd.bind(this));
        });
      }
    }
    
    handleHoverStart() {
      // 호버 시작 시 이미지들을 위로 올리기
      clearTimeout(this.hoverTimeout);
      this.mediaItems.forEach(item => {
        item.style.transform = "translateY(-10px)";
        item.style.transition = "transform 0.3s ease";
      });
    }
    
    handleHoverEnd() {
      // 호버 종료 시 이미지들을 원래 위치로 되돌리기
      this.hoverTimeout = setTimeout(() => {
        this.mediaItems.forEach(item => {
          item.style.transform = "translateY(0)";
        });
      }, 100); // 약간의 지연을 주어 자연스러운 효과
    }
  }
  customElements.define("addtocart-hover-lift", addtocartHoverLift);
}

// 자동으로 요소 생성
document.addEventListener("DOMContentLoaded", function() {
  if (!document.querySelector("addtocart-hover-lift")) {
    const hoverLiftElement = document.createElement("addtocart-hover-lift");
    document.body.appendChild(hoverLiftElement);
  }
});
